export const HOVER_CLOSE_DELAY_MS = 150
